import authImageError from "@assets/images/Error403.svg";
import { Empty } from "@nexus/shared-ui";
import { Flex, Image, Typography } from "antd";
import { ResultStatusType } from "antd/es/result";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSearchParams } from "react-router";
const { Title } = Typography;

const ErrorPage = ({ status: statusProps = "404" }) => {
  const { t } = useTranslation();

  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<ResultStatusType>("404");

  useEffect(() => {
    if (searchParams.get("status") === "403") {
      setStatus("403");
      return;
    }
    if (searchParams.get("status") === "404") {
      setStatus("404");
      return;
    }

    if (statusProps === "403") {
      setStatus("403");
      return;
    }
  }, [searchParams, statusProps]);

  return (
    <Flex
      align="center"
      justify="center"
      gap={16}
      className="not-found-page-wrapper"
    >
      {status === "403" ? (
        <Empty
          title={"403"}
          description={t("notification.403")}
          icon={<Image src={authImageError} preview={false} />}
        />
      ) : (
        <>
          <div className="not-found-bg-wrapper" />
          <Title level={1} className="title">
            {status}
          </Title>
          <Title level={4} className="description">
            {t(`notification.${status}`)}
          </Title>
          {/* <Link to="/">
            <Button type="primary">{t("menu.home.index")}</Button>
          </Link> */}
        </>
      )}
    </Flex>
  );
};

export default ErrorPage;
